import type { SymbolKey } from './types';

export function parseSymbolKey(value: string): SymbolKey {
  const parsedValue = value.split(' ');

  return {
    Code: parsedValue[0],
    Period: parsedValue[3],
    PeriodType: parsedValue[2],
    TimeRef: parsedValue[1]
  };
}

export function parseSymbolKeys(value: string): SymbolKey[] {
  return value
    .split('|')
    .map(s => s.trim())
    .filter(Boolean)
    .map(parseSymbolKey);
}
